const Ranga = Object.freeze({
  MP: { key: 'MP', value: 'Mistrzostwa Polski' },
  PP: { key: 'PP', value: 'Puchar Polski TU/TZ' },
  PPM: { key: 'PPM', value: 'Puchar Polski TD/TM/TJ' },
  O: { key: 'O', value: 'Impreza Ogólnopolska' },
});

export default Ranga;